module.exports = __webpack_public_path__ + "img/mealreminder-minip-small.cc0026d9.png";